import React from 'react';
import { TextField, Grid, Box } from '@mui/material';
import { callApi } from '../../../utils/apiClient';
import { API_ENDPOINTS } from '../../../config/api/apiCall';
 // import the action menu
import BankActionMenu from './BankActionMenu';

const AddUpdateBank = ({ bankFormData, setBankFormData, setIsFormOpen, LoadBankList }) => {
  //const isEdit = !!bankFormData?.sbank_id; // true if editing
const isEdit = !!(bankFormData?.sbank_id && bankFormData.sbank_id !== 0);
const bankId = bankFormData?.sbank_id || 0;
  const handleSave = () => {
    const payload = {
    ...bankFormData,
    sbank_id: bankId,
    scompany_id: localStorage.getItem('companyid'),
    splant_id: 1,
    screated_by: localStorage.getItem('userID')
  };
   // callApi(API_ENDPOINTS.MASTER_GET_BANK_LIST, 'POST', { 'Content-Type': 'application/json' })
    callApi(API_ENDPOINTS.MASTER_SAVE_UPDATE_BANK, 'POST', { 'Content-Type': 'application/json' }, payload)
      .then(() => {
        LoadBankList();
        setIsFormOpen(false);
      });
  };

  const handleDelete = () => {
    if (!isEdit) return;
     const payload = {
    ...bankFormData,
    sbank_id: bankId,
    scompany_id: localStorage.getItem('companyid'),
    splant_id: 1,
    screated_by: localStorage.getItem('userID')
  };
    callApi(API_ENDPOINTS.MASTER_DELETE_BANK, 'POST', { 'Content-Type': 'application/json' }, payload)
    //callApi(`${API_ENDPOINTS.MASTER_DELETE_BANK}/${bankFormData.sbank_id}`, 'DELETE',payload)
      .then(() => {
        LoadBankList();
        setIsFormOpen(false);
      });
  };

  const handleExit = () => setIsFormOpen(false);

  return (
    <Box p={3}>
      {/* Action Menu */}
      <BankActionMenu
        isEdit={isEdit}
        onSave={handleSave}
        onDelete={handleDelete}
        onExit={handleExit}
        saveDisabled={!bankFormData.sbank_code || !bankFormData.sbank_name} // disable save if fields empty
      />

      <Grid item xs={12} sm={6}>
  <TextField
    fullWidth
    label="Bank Code"
    value={bankFormData.sbank_code || ''}
    onChange={(e) =>
      setBankFormData({ ...bankFormData, sbank_code: e.target.value.toUpperCase() })
    }
    inputProps={{ style: { textTransform: 'uppercase' } }} // visual uppercase
  />
</Grid>

<Grid item xs={12} sm={6}>
  <TextField
    fullWidth
    label="Bank Name"
    value={bankFormData.sbank_name || ''}
    onChange={(e) =>
      setBankFormData({ ...bankFormData, sbank_name: e.target.value.toUpperCase() })
    }
    inputProps={{ style: { textTransform: 'uppercase' } }} // visual uppercase
  />
</Grid>

    </Box>
  );
};

export default AddUpdateBank;
